import { updateObject, } from '../../utils/utility';

const initialState = {
    financialList: [],
    totalFinancial: 0,
    pageNumber: 0,
    totalPage: 0,
    companyList: [],
    legalEntityList: [],
    paymentStatusList: []
}

const setMyPaymentsData = (state = initialState, action) => {
    const { financialList, totalFinancial, pageNumber, totalPage, companyList, legalEntityList, paymentStatusList } = action.payload;
    const updateFinancialList = [];
    financialList.map(financialData => {
        let isCustomerInvoiceNumberDisabled = false;
        let isCustomerPoNoDisabled = false;
        if (financialData.paymentType === 'HP Payment + HP2B') {
            if (financialData.lineType === "hardware" && financialData.customerInvoiceNo) {
                isCustomerInvoiceNumberDisabled = true;
            }
            if (financialData.lineType === "service" && financialData.customerPONo) {
                isCustomerPoNoDisabled = true;
            }
        }
        if (financialData.paymentType === 'HP Payment + CMO') {
            if (financialData.lineType === "hardware" && financialData.customerInvoiceNo) {
                isCustomerInvoiceNumberDisabled = true;
            }
            if (financialData.lineType === "service" && financialData.customerPONo) {
                isCustomerPoNoDisabled = true;
            }
        }
        
        updateFinancialList.push({ ...financialData, isCustomerInvoiceNumberDisabled, isCustomerPoNoDisabled });
    });

    return updateObject(state, {
            financialList: updateFinancialList,
            totalFinancial,
            pageNumber,
            totalPage,
            companyList,
            legalEntityList,
            paymentStatusList
        }
    );
};

const updateMyPaymentdata = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { financialList } = state;
    financialList[rowIndex] = { ...financialList[rowIndex], [columnName]: value };
    return updateObject(state, { financialList });
} 

const reducer = (state = initialState, action) => {
    if (action.type === "SET_DIRECT_CUSTOMER_PAYMENTS_LIST") {
        return setMyPaymentsData(state, action);
    }
    else if (action.type === "UPDATE_DIRECT_CUSTOMER_PAYMENTS_LIST") {
        return updateMyPaymentdata(state, action);
    }
    return state;
}

export default reducer;